(function () {
  var header = document.querySelector('[data-gelazo-header]');

  if (!header) {
    return;
  }

  var setHeaderState = function () {
    if (window.scrollY > 8) {
      header.setAttribute('data-scrolled', 'true');
    } else {
      header.removeAttribute('data-scrolled');
    }
  };

  setHeaderState();
  window.addEventListener('scroll', setHeaderState, { passive: true });
})();
